import $ from 'jquery';

$(document).ready(function() {
  const $body = $('body');

  // Initial effect
  $(window).on('load', () => {
    $body.addClass('loaded');
  });

  // Leaving effect
  $(window).bind('beforeunload', function() {
    $body.removeClass('loaded')
  });

  // Fallback
  setTimeout(() => {
    if (!$body.hasClass('loaded')) {
      $body.addClass('loaded');
    }
  }, 2000)
});



// WEBPACK FOOTER //
// ./app/ui/elements/loader/index.js